import _defineProperty from "babel-runtime/helpers/defineProperty";

var _headers;

/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable max-statements-per-line */
/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
/**
 * Cart methods
 * -----------------------------------------------------------------------------
 *
 * @namespace cart
 */

import axios from 'axios';
// date picker component
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

// IE11 bug: we need to disable cache for this request
var axiosConfig = {
	headers: (_headers = {
		'Cache-Control': 'must-revalidate'
	}, _defineProperty(_headers, "Cache-Control", 'no-cache'), _defineProperty(_headers, "Cache-Control", 'no-store'), _defineProperty(_headers, "Pragma", 'no-cache'), _headers)
};

var cartMethods = {
	components: {
		flatPickr: flatPickr
	},

	data: function data() {
		return {
			isCartAjaxed: false,
			loadingEvent: null,
			cart: {},
			cartError: false,
			cartinViewport: false,
			iscartLoaded: false,
			// shipping calculator
			countries: window.Countries,
			provinces: null,
			selectedCountry: null,
			selectedProvince: null,
			selectedZip: null,
			zipRequired: false,
			shippingRates: null,
			shippingRatesErrors: null,
			limitedError: true,
			isLimitedError: false,
			// date picker
			// get more from https://chmln.github.io/flatpickr/options/
			datePickerConfig: {
				wrap: true, // set wrap to true only when using 'input-group'
				altFormat: 'M j, Y',
				altInput: true,
				dateFormat: 'm-d-Y',
				enableTime: false,
				locale: {
					firstDayOfWeek: 1 // start week on Monday
				},
				// minDate: "today",
				minDate: new Date().fp_incr(2), // 2 days from now

				// disable Saturdays and Sundays - disable using a function
				disable: [function (date) {
					// must return true to disable
					return date.getDay() === 6 || date.getDay() === 0;
				}]
			}
		};
	},


	watch: {
		selectedCountry: function selectedCountry() {
			var selectedCountryObj = app.countries[app.selectedCountry];
			var selectedProvincesObj = selectedCountryObj.province_alternate_names;
			var provincesLength = Object.keys(selectedProvincesObj).length;

			// clear data
			app.shippingRates = null;
			app.shippingRatesErrors = null;
			app.selectedZip = null;

			// set data
			app.zipRequired = selectedCountryObj.zip_required;

			if (provincesLength > 0) {
				app.provinces = selectedProvincesObj;
				// app.selectedProvince = Object.keys(app.provinces)[0]
			} else {
				app.provinces = null;
			}
		}
	},

	methods: {
		_initCart: function _initCart() {
			var isCartAjaxed = $('[data-template="cart"]').data('cart-ajaxed');

			if (isCartAjaxed) {
				app.isCartAjaxed = true;
			}

			app._getCartData();
			// shipping calculator
			app._initShippingCalculator();
			app._isInViewport();
			$(window).on('load scroll', function () {
				app._isInViewport();
			});
		},
		_isInViewport: function _isInViewport() {
			if ($('[data-checkoutBox]').length > 0) {
				var elementTop = $('[data-checkoutBox]').offset().top;
				var elementBottom = elementTop + $('[data-checkoutBox]').outerHeight();
				var viewportTop = $(window).scrollTop();
				var viewportBottom = viewportTop + $(window).height();
				if (elementBottom > viewportTop && elementTop < viewportBottom) {
					app.cartinViewport = true;
				} else {
					app.cartinViewport = false;
				}
			}
		},
		_mergeObjs: function _mergeObjs(def, obj) {
			if (typeof obj === 'undefined') {
				return def;
			} else if (typeof def === 'undefined') {
				return obj;
			}
			for (var i in obj) {
				if (obj[i] != null && obj[i].constructor === Object) {
					def[i] = app._mergeObjs(def[i], obj[i]);
				} else {
					def[i] = obj[i];
				}
			}
			return def;
		},
		_getCartDefault: function _getCartDefault() {
			return axios.get('/cart.js', axiosConfig);
		},
		_getCartExtra: function _getCartExtra() {
			return axios.get('/cart?view=extra.json', axiosConfig);
		},


		/**
		 * Get the cart data json object
		 */
		_getCartData: function _getCartData() {
			// we make our own enhanced version of the cart object.
			// we are merging Shopify's default cart object
			// and some more additional data like product options and metafields
			// eslint-disable-next-line promise/catch-or-return
			app.iscartLoaded = false;
			axios.all([app._getCartDefault(), app._getCartExtra()]).then(axios.spread(function (basic, extra) {
				// Both requests are now complete
				var basicCartData = basic.data;
				var mergedItems = app._mergeObjs(basic.data.items, extra.data.items);
				// console.log(extra.data.items);
				basicCartData.items = mergedItems;

				basicCartData.items.forEach(function (item) {
					if (!item.properties) {
						item.properties = [];
					}
					if (item.tags.indexOf('Extra_Care') >= 0 || item.tags.indexOf('LTL') >= 0) {
						app.enablefreeShipMsg = false;
					}
				});

				// enablefreeShipMsg
				app.cart = basicCartData;

				app._initCartUpsells();
				app._initCartPromos();
				setTimeout(function () {
					app.iscartLoaded = true;
				}, 500);
				setTimeout(function () {
					app._getCampaingCode();
				}, 500);
			}));
		},
		_getProductDataAnalytics: function _getProductDataAnalytics(handle) {
			var selectedProduct = [];
			axios.get("/products/" + handle + ".js").then(function (response) {
				selectedProduct.push(response.data);
			});
			return selectedProduct;
		},
		_dataLayerEvent: function _dataLayerEvent(proDataAnalytics, eventName, internalId, qtyValue) {
			var catLevel1 = void 0; var catLevel3 = void 0; var catLevel2 = void 0;
			$(proDataAnalytics[0].tags).each(function (i, tag) {
				if (tag.indexOf('spcat_') > -1) {
					catLevel1 = tag.replace('spcat_', '');
					catLevel1 = catLevel1.replace(/_/g, ' ');
					catLevel1 = catLevel1.substring(0,1).toUpperCase() + catLevel1.slice(1);
				}
				if (tag.indexOf('sbcat_') > -1) {
					catLevel3 = tag.replace('sbcat_', '');
					catLevel3 = catLevel3.replace(/_/g, ' ');
					catLevel3 = catLevel3.substring(0,1).toUpperCase() + catLevel3.slice(1);
				}
				if (tag.indexOf('spcat_') <= -1 && tag.indexOf('sbcat_') <= -1) {
					if (tag.indexOf('cat_') > -1) {
						catLevel2 = tag.replace('cat_', '');
						catLevel2 = catLevel2.replace(/_/g, ' ');
						catLevel2 = catLevel2.substring(0,1).toUpperCase() + catLevel2.slice(1);
					}
				}
			});
			var proTitle = proDataAnalytics[0].variants[0].sku + " " + proDataAnalytics[0].title;
			var price = app._formatMoney(proDataAnalytics[0].price).replace('$', '').replace(',', '');
			price = Number(price);
			var proVariant = proDataAnalytics[0].variants[0].name;
			var dlEvent = {
				event: eventName,
				ecommerce: {}
			};
			switch (eventName) {
				case 'QuantityAddtoCart':
				case 'addToCart':
					dlEvent.ecommerce = {
						currencyCode: 'USD',
						add: {
							products: [{
								name: proTitle,
								id: internalId,
								price: price,
								brand: proDataAnalytics[0].vendor,
								category: catLevel1 + "/" + catLevel2 + "/" + catLevel3,
								variant: proVariant,
								quantity: qtyValue,
								dimension5: catLevel1,
								dimension6: catLevel2,
								dimension7: catLevel3
							}]
						}
					};
					break;
				case 'eec_remove':
					dlEvent.ecommerce = {
						remove: {
							products: [{
								name: proTitle,
								id: internalId,
								brand: proDataAnalytics[0].vendor,
								category: catLevel1 + "/" + catLevel2 + "/" + catLevel3,
								variant: proVariant,
								quantity: qtyValue,
								dimension5: catLevel1,
								dimension6: catLevel2,
								dimension7: catLevel3
							}]
						}
					};
					break;
				default:
					break;
			}
			dataLayer.push(dlEvent);
		},


		/**
		 * Event to add a variant to the cart
		 * adds item properties from hidden fields automatically
		 *
		 * @param  {number} variantId - current variant id
		 */
		_addToCart: function _addToCart(variantId, event) {
			var cartProduct = app.cart.items.find(function (x) {
				return x.variant_id === variantId;
			});
			var $form = $(event.currentTarget).closest(app.selectors.productForm);
			var $qtyEl = $form.find(app.selectors.qtyInput) || null;
			var qtyValue = $qtyEl.val() || 1;
			var productCartLimit = $(event.currentTarget).attr('data-cart-limit') || null;
			var totalQty = cartProduct ? Number(qtyValue) + Number(cartProduct.quantity) : qtyValue;
			var properties = {};
			var productAddons = app.storeUtilities.productAddons.products;
			var proEleHandle = $.trim($form.attr('data-handle'));
			var proDataAnalytics = app._getProductDataAnalytics(proEleHandle);
			// const selectedVariantsSku = $(event.target).closest('form').find('[name="id"] option:selected').attr('data-sku');
			var internalId = $form.attr('data-hawkid');

			Shopify.queue = [];
			app.limitedError = false;
			app.isLimitedError = false;
			// add cart limit property
			if (productCartLimit) {
				properties.cart_limit = productCartLimit;
			}

			// check if item has product limit assigned
			if (app._productHasCartLimit(totalQty, productCartLimit)) {
				app.limitedError = true;
				app.isLimitedError = true;
				$('[data-addedModal]').modal('show');
				$($qtyEl).val(productCartLimit);
				if (app.currentTemplate !== 'product') {
					app._snotifyMessage('Error!', 'Cart Limit for this product Exceeded.');
				}
				return;
			}

			app.isLoading = true;

			// eslint-disable-next-line no-empty
			if ($form.attr('data-formType') === 'sticky') {
				app.loadingEvent = 'StickycartAdding';
			} else if ($form.attr('data-formType') === 'product-listing') {
				app.loadingEvent = "cartAdding_" + variantId;
			} else {
				app.loadingEvent = 'cartAdding';
			}

			var $formProperties = $($form).find('input[name*="properties"]');
			// Pass all properties to the cart line item
			$.each($($formProperties).serializeArray(), function () {
				var name = this.name.replace('properties[', '').replace(']', '');
				properties[name] = this.value;
			});


			// push the default variantId to the Shopify queue
			Shopify.queue.push({
				variantId: variantId
			});

			// if there are selected product add-ons
			// push them also to the Shopify queue
			if (productAddons.length > 0) {
				productAddons.forEach(function (product) {
					if (product.selected) {
						Shopify.queue.push({
							variantId: product.variants[0].id
						});
					}
				});
			}

			Shopify.moveAlong = function () {
				// If we still have requests in the queue, let's process the next one.
				if (Shopify.queue.length) {
					var request = Shopify.queue.shift();
					axios.post('/cart/add.js', {
						quantity: qtyValue,
						id: request.variantId,
						properties: properties
					}).then(function (response) {
						if ($form.length > 0) {
							var proPrice = $form.attr('data-price');
							proPrice = proPrice.replace('$', '');
							proPrice = proPrice.replace('USD', '');

							// HawkSearch Event Tracking
							HawkSearch.Tracking.track('add2cart', {
								uniqueId: $form.attr('data-hawkid'),
								price: proPrice,
								quantity: qtyValue,
								currency: 'USD'
							});
							gtag('event', 'add_to_cart', {
								value: proPrice,
								items: [{
									id: $form.attr('data-productid'),
									google_business_vertical: 'retail'
								}]
							});
						}

						Shopify.moveAlong();
						return response.data;
					}).catch(function (error) {
						// console.log(error)
						if (Shopify.queue.length) {
							Shopify.moveAlong();
						}
						throw error;
					});
				} else {
					if (app.currentTemplate === 'cart' && !app.isCartAjaxed) {
						location.reload();
					}
					app._getCartData();
					app._vibrateDevice();
					$qtyEl.val(1); // reset qty input to 1
					app.$snotify.clear();
					var cart_value = app._formatMoney(app.cart.total_price).replace('$', '').replace(',', '');
					setTimeout(function () {
						app.isLoading = false;
						app.loadingEvent = null;

						app._dataLayerEvent(proDataAnalytics, 'addToCart', internalId, qtyValue);
						if ($form.attr('data-formType') !== 'product-listing') {
							window.location.href = '/pages/pre-checkout';
						} else {
							app._snotifyMessageSuccess('Added!', 'Item has been Added to cart.');
						}
						if (app.currentTemplate !== 'product') {
							if (app.storeUtilities.cartUpsells.settings.showOnPopUp) {
								var recentItem = app.cart.items.find(function (x) {
									return x.variant_id === variantId;
								});
								app._openModalCartUpsell(recentItem);
							} else {
								app._toggleCartDrawer();
							}
						}
					}, 500);
				}
			};
			Shopify.moveAlong();
		},


		// addtocart from wishlist page
		_addToCartFromWishlist: function _addToCartFromWishlist(variantId, event) {
			var qtyValue = 1;
			var productCartLimit = $(event.currentTarget).attr('data-cart-limit') || null;
			var properties = {};
			var $form = $(event.currentTarget).closest(app.selectors.productForm);
			Shopify.queue = [];
			var cartProduct = app.cart.items.find(function (x) {
				return x.variant_id === variantId;
			});
			var totalQty = cartProduct ? Number(qtyValue) + Number(cartProduct.quantity) : qtyValue;
			var proEleHandle = $.trim($form.attr('data-handle'));
			var proDataAnalytics = app._getProductDataAnalytics(proEleHandle);
			var internalId = $form.attr('data-hawkid');

			// add cart limit property
			if (productCartLimit) {
				properties.cart_limit = productCartLimit;
			}

			// check if item has product limit assigned
			if (app._productHasCartLimit(totalQty, productCartLimit)) {
				app._snotifyMessage('Error!', 'Cart Limit for this product Exceeded.');
				return;
			}

			var $formProperties = $($form).find('input[name*="properties"]');
			// Pass all properties to the cart line item
			$.each($($formProperties).serializeArray(), function () {
				var name = this.name.replace('properties[', '').replace(']', '');
				properties[name] = this.value;
			});

			app.isLoading = true;
			app.loadingEvent = "cartAdding" + variantId;

			axios.post('/cart/add.js', {
				quantity: qtyValue,
				id: variantId,
				properties: properties
			}).then(function (response) {
				var proPrice = $form.attr('data-price');
				proPrice = proPrice.replace('$', '');
				proPrice = proPrice.replace('USD', '');
				// HawkSearch Event Tracking
				HawkSearch.Tracking.track('add2cart', {
					uniqueId: $form.attr('data-hawkid'),
					price: proPrice,
					quantity: qtyValue,
					currency: 'USD'
				});
				gtag('event', 'add_to_cart', {
					value: proPrice,
					items: [{
						id: $form.attr('data-productid'),
						google_business_vertical: 'retail'
					}]
				});
				app._getCartData();
				app._vibrateDevice();
				app.$snotify.clear();
				var cart_value = app._formatMoney(app.cart.total_price).replace('$', '').replace(',', '');
				setTimeout(function () {
					// Pintrest Event Tracking            

					pintrk('track', 'addtocart', {
						value: cart_value,
						order_quantity: qtyValue,
						currency: 'USD',
						line_items: [{
							product_id: variantId
						}]
					});
					app.isLoading = false;
					app.loadingEvent = null;
					app._dataLayerEvent(proDataAnalytics, 'addToCart', internalId, qtyValue);
					window.location.href = '/pages/pre-checkout';
				}, 500);
				return response.data;
			}).catch(function (error) {
				// console.log(error)
				throw error;
			});
		},


		/**
		 * Event to remove a variant from the cart
		 *
		 * @param  {number} itemId - line item index
		 */
		_removeFromCart: function _removeFromCart(itemIndex, event) {
			var $cartItem = $(event.currentTarget).parentsUntil(app.selectors.cartItem).parent();
			var proEleHandle = $.trim($(event.currentTarget).attr('data-handle'));
			var internalId = $(event.currentTarget).attr('data-internal');
			var proDataAnalytics = app._getProductDataAnalytics(proEleHandle);
			var qtyRemoved = $cartItem.find(app.selectors.qtyInput).val() || 0;

			app.isLoading = true;
			$cartItem.addClass('updating');

			axios.post('/cart/change.js', {
				quantity: 0,
				line: itemIndex
			}).then(function (response) {
				app.isLoading = false;
				app._getCartData();
				app._dataLayerEvent(proDataAnalytics, 'eec_remove', internalId, qtyRemoved);
				$('[data-toggle="tooltip"]').tooltip('hide');
				return response;
			}).catch(function (error) {
				// console.log(error)
				throw error;
			});
		},


		/**
		 * Event to update a variant in the cart
		 *
		 * @param  {number} itemIndex - line item index
		 */
		_updateCart: function _updateCart(itemIndex, event) {
			var $qtyEl = $(event.currentTarget).parentsUntil(app.selectors.qtyContainer).find(app.selectors.qtyInput);
			var $cartItem = $(event.currentTarget).closest(app.selectors.cartItem);
			var proEleHandle = $.trim($(event.currentTarget).attr('data-handle'));
			var internalId = $(event.currentTarget).attr('data-internal');
			var proDataAnalytics = app._getProductDataAnalytics(proEleHandle);
			var productCartLimit = $cartItem.data('cart-limit') || null;
			var qtyValue = $qtyEl.val();
			app.cartError = false;
			var qtyDifference;

			if ($(event.currentTarget).data('qty-decrease') !== undefined) {
				if (parseFloat(qtyValue) >= 2) {
					qtyValue = parseFloat(qtyValue) - 1;
					qtyDifference = -1;
				}
			} else if ($(event.currentTarget).data('qty-increase') !== undefined) {
				qtyValue = parseFloat(qtyValue) + 1;
				qtyDifference = 1;

				// check if item has product limit assigned
				if (app._productHasCartLimit(qtyValue, productCartLimit)) {
					app.cartError = true;
					return;
				}
			} else {
				var lineItemFound = false;
				app.cart.items.forEach(function (cartLineItem) {
					if (!lineItemFound && cartLineItem.InternalId === parseInt(internalId)) {
						qtyDifference = qtyValue - cartLineItem.quantity;
						lineItemFound = true;
					}
				});
			}

			app.isLoading = true;
			$cartItem.addClass('updating');

			$($qtyEl).parent().css({
				'pointer-events': 'none'
			});

			axios.post('/cart/change.js', {
				quantity: qtyValue,
				line: itemIndex
			}).then(function (response) {
				app._getCartData();
				app.isLoading = false;
				$cartItem.removeClass('updating');
				$($qtyEl).parent().css({
					'pointer-events': 'inherit'
				});
				if (qtyDifference > 0) {
					app._dataLayerEvent(proDataAnalytics, 'QuantityAddtoCart', internalId, qtyDifference);
				} else if (qtyDifference < 0) {
					app._dataLayerEvent(proDataAnalytics, 'eec_remove', internalId, Math.abs(qtyDifference));
				}
				//app._dataLayerEvent(proDataAnalytics, 'QuantityAddtoCart', internalId, qtyValue);
				return response;
			}).catch(function (error) {
				// console.log(error)
				throw error;
			});
		},
		_productHasCartLimit: function _productHasCartLimit(qtyValue, productCartLimit) {
			// console.log(`qtyValue: ${qtyValue}, productCartLimit: ${productCartLimit}`);
			if (productCartLimit) {
				if (qtyValue > productCartLimit) {
					/* app.$snotify.warning(`Product cart limit applies for the specific product variant. You can't purchase more than ${productCartLimit} item(s) per order.`, 'Product Limit', {
					  timeout: 10000,
					  showProgressBar: true,
					  closeOnClick: true,
					  pauseOnHover: true,
					  buttons: [{
						text: 'Close',
						bold: true,
						closeOnClick: true,
						// action: (toast) => {
						//   app.$snotify.remove(toast.id);
						// },
					  }],
					});*/
					return true;
				}
			}
			return false;
		},


		/**
		 * ShippingCalculator
		 */
		_initShippingCalculator: function _initShippingCalculator() {
			var $form = $('[data-shipping-calculator]');
			if ($form.length === 0) {
				return;
			}

			var customerCountry = $form.find('select[name="country"]').data('value').trim();
			var customerProvince = $form.find('select[name="province"]').data('value').trim();
			var customerZip = $form.find('input[name="zip"]').data('value').trim();
			var userCountry = app._getCookie('user_country');
			var userProvince = app._getCookie('user_province');
			var today = new Date();
			var expirationDate = new Date();
			expirationDate.setDate(today.getDate() + 7);
			var time = expirationDate.getTime();
			var expireTime = time + 1000 * 36000;
			expirationDate.setTime(expireTime);

			if (customerCountry) {
				// if is user (is logged-in) show the user data
				app.selectedCountry = customerCountry;
				app.selectedProvince = customerProvince;
				app.selectedZip = customerZip;
			} else if (userCountry !== 'user_country' && userProvince !== 'user_province') {
				// else if cookie exists get from cookie
				app.selectedCountry = userCountry;
				app.selectedProvince = userProvince;
			} else {
				// finally if we don't have any data => get info from IP
				axios.get('https://geoip-db.com/json/').then(function (response) {
					app.selectedCountry = response.data.country_name;
					app.selectedProvince = response.data.region_name;
					// app.selectedZip = response.data.zip_code

					// set cookies
					document.cookie = "user_country=" + response.data.country_name + ";expires=" + expirationDate.toGMTString() + ";path=/";
					document.cookie = "user_province=" + response.data.region_name + ";expires=" + expirationDate.toGMTString() + ";path=/";
					return response;
				}).catch(function (error) {
					// console.log(error)
					throw error;
				});
			}
		},
		_getCartShippingRates: function _getCartShippingRates() {
			app.isLoading = true;

			axios.post('/cart/prepare_shipping_rates', {
				shipping_address: {
					country: app.selectedCountry,
					province: app.selectedProvince,
					zip: app.selectedZip
				}
			}).then(function (response) {
				app._pollCartShippingRates();
				return response;
			}).catch(function (error) {
				// console.log(error.response.data)
				app.isLoading = false;
				app.shippingRatesErrors = error.response.data;
				throw error;
			});
		},
		_pollCartShippingRates: function _pollCartShippingRates() {
			axios.get('/cart/async_shipping_rates').then(function (response) {
				app.isLoading = false;
				if (response.data && response.data.shipping_rates) {
					app.shippingRates = response.data.shipping_rates;
				}
				return response;
			}).catch(function (error) {
				// console.log(error)
				throw error;
			});
		},


		/**
		 * Vibrate mobile device
		 */
		_vibrateDevice: function _vibrateDevice() {
			// check for vibration support
			var vibrationEnabled = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
			if (vibrationEnabled) {
				navigator.vibrate(100);
			}
		}
	}
};

export default cartMethods;